import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { formatSignedPoints } from "./formatPoints";
import { sanitizeAwardMessage } from "@/utils/sanitizeAwardMessage";

// Long histories start collapsed: the newest rows first, then more on request
export const INITIAL_ROWS = 10;
export const MORE_ROWS = 25;

export const PointsDetail = ({ program, eventHistory = [] }) => {
  const { t } = useTranslation();
  const [visibleCount, setVisibleCount] = useState(INITIAL_ROWS);
  if (eventHistory.length === 0) return null;

  const total = eventHistory.length;
  const shown = Math.min(visibleCount, total);

  const fmt = (ts) => {
    if (!ts) return "-";

    const parsed = new Date(String(ts).replace(' ', 'T'));

    if (Number.isNaN(parsed.getTime())) return "-";

    return parsed.toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
    });
  };

  return (
    <div className="mp-table-wrap">
      <h2 className="mp-table-wrap__title">{t('points_detail')}</h2>
      <table className="mp-table">
        <thead>
          <tr>
            <th>{t('event')}</th>
            <th>{t('award_message')}</th>
            <th>{t('date')}</th>
            <th>{t('Awarder')}</th>
            <th className="mp-table__num">{t('points')}</th>
          </tr>
        </thead>
        <tbody>
          {eventHistory.slice(0, shown).map((row, i) => {
            const amount = Number(row.amount ?? 0);
            const pointsClass =
              amount > 0 ? 'mp-table__pts--pos' : amount < 0 ? 'mp-table__pts--neg' : '';
            const awarder = `${row.first_name ?? ''} ${row.last_name ?? ''}`.trim() || '-';
            const awardMessage = sanitizeAwardMessage(row.notification_body);
            return (
              <tr key={row.journal_event_id ?? i}>
                <td data-label={t('event')}>{row.name}</td>
                <td className="award-message-cell" data-label={t('award_message')}>
                  {awardMessage ? <span dangerouslySetInnerHTML={{ __html: awardMessage }} /> : '-'}
                </td>
                <td className="mp-table__date" data-label={t('date')}>{fmt(row.journal_event_timestamp)}</td>
                <td data-label={t('Awarder')}>{awarder}</td>
                <td className={`mp-table__num ${pointsClass}`.trim()} data-label={t('points')}>
                  {formatSignedPoints(row.amount * program.factor_valuation)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {total > INITIAL_ROWS && (
        <div className="mp-table-wrap__more">
          <span className="mp-table-wrap__count">{t('showing_x_of_y', { shown, total })}</span>
          <div className="mp-table-wrap__more-actions">
            {shown > INITIAL_ROWS && (
              <button type="button" className="mp-table-wrap__more-btn" onClick={() => setVisibleCount(INITIAL_ROWS)}>
                {t('show_less')}
              </button>
            )}
            {shown < total && (
              <button
                type="button"
                className="mp-table-wrap__more-btn mp-table-wrap__more-btn--primary"
                onClick={() => setVisibleCount((count) => count + MORE_ROWS)}
              >
                {t('show_more')}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  program: state.program,
});

export default connect(mapStateToProps)(PointsDetail);
